export default (orderBy) => {
    const order = [];

    // NOTE: the order of these properties must match order in the 'Strive Agent Pipeline Details' query (/src/data/queries.sql)
    const columns = [
        'STATUS',
        'CLOSE_OF_ESCROW',
        'LISTING_DATE',
        'DATE_CREATED',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    if (orderBy) {
        const orders = Array.isArray(orderBy) ? orderBy : [orderBy];
        orders.forEach(x => {
            const [code, direction] = x.split('.');

            columns.some((column, i)=> {
                if (column === code) {
                    order.push('CO'+(i*2+(direction === 'asc' ? 1 : 2)));
                    return true;
                }
            })
        });
    }

    order.push('CO'+(columns.length*2)); // ARCIMEDES_ROW_ID descending

    return order;
};